import { ApiEndPoint } from './apiUttiLities';
import { JwtService } from './jwtapi';

const request = (path, method = 'GET', data = {}) => (
  JwtService.commanApi(data, `${ApiEndPoint}/api${path}`, method)
);

export const SaaSServices = {
  selectInstitution: (selectionToken, institutionId) => request('/auth/select-institution', 'POST', {
    selection_token: selectionToken,
    institution_id: institutionId,
  }),
  acceptInvitation: (payload) => request('/auth/accept-invitation', 'POST', payload),
  getInvitation: (token) => request(`/auth/invitation?token=${encodeURIComponent(token)}`),
  listMyInstitutions: () => request('/auth/institutions'),
  switchInstitution: (institutionId) => request('/auth/switch-institution', 'POST', {
    institution_id: institutionId,
  }),

  listInstitutions: () => request('/saas/institutions'),
  getOperationsAreaCountryBoundary: (countryIso2) => request(
    `/saas/operations-area/countries/${encodeURIComponent(String(countryIso2 || '').trim().toUpperCase())}/boundary`,
  ),
  provisionInstitution: (payload) => request('/saas/institutions', 'POST', payload),
  updateInstitution: (institutionId, payload) => request(`/saas/institutions/${institutionId}`, 'PATCH', payload),
  getInstitutionLicense: (institutionId) => request(`/saas/institutions/${institutionId}/license`),
  updateInstitutionLicense: (institutionId, payload) => request(`/saas/institutions/${institutionId}/license`, 'PUT', payload),
  getRetentionBoundaries: () => request('/saas/retention-boundaries'),
  updateRetentionBoundaries: (payload) => request('/saas/retention-boundaries', 'PUT', payload),
  listGlobalSupportUsers: () => request('/saas/support-users'),
  listSaaSSupportRequests: () => request('/saas/support-requests'),
  assignSaaSSupportRequest: (grantId, supportUserId) => request(`/saas/support-requests/${grantId}`, 'PATCH', {
    support_user_id: supportUserId,
  }),
  claimSaaSSupportRequest: (grantId) => request(`/saas/support-requests/${grantId}/claim`, 'POST'),
  closeSupportCase: (grantId, resolution) => request(`/saas/support-cases/${grantId}/close`, 'POST', {
    resolution,
  }),
  getGlobalMarketplacePolicy: () => request('/saas/scenario-marketplace-policy'),
  updateGlobalMarketplacePolicy: (payload) => request('/saas/scenario-marketplace-policy', 'PUT', payload),
  listMarketplaceReviews: (status = '') => request(`/saas/scenario-marketplace/listings${status ? `?status=${encodeURIComponent(status)}` : ''}`),
  reviewMarketplaceListing: (listingId, payload) => request(`/saas/scenario-marketplace/listings/${listingId}`, 'PATCH', payload),
  listBreakGlassGrants: (institutionId) => request(`/saas/institutions/${institutionId}/break-glass-grants`),
  createBreakGlassGrant: (institutionId, payload) => request(`/saas/institutions/${institutionId}/break-glass-grants`, 'POST', payload),
  revokeBreakGlassGrant: (institutionId, grantId) => request(`/saas/institutions/${institutionId}/break-glass-grants/${grantId}`, 'DELETE'),

  listMemberships: () => request('/institutions/current/memberships'),
  getUsersAccess: () => request('/institutions/current/users-access'),
  updateMembership: (membershipId, payload) => request(`/institutions/current/memberships/${membershipId}`, 'PATCH', payload),
  revokeMembership: (membershipId) => request(`/institutions/current/memberships/${membershipId}`, 'DELETE'),
  previewMembershipActivation: (membershipIds) => request('/institutions/current/memberships/activation-preview', 'POST', {
    ...(Array.isArray(membershipIds) ? { membership_ids: membershipIds } : {}),
  }),
  activateMemberships: (membershipIds) => request('/institutions/current/memberships/activate-bulk', 'POST', {
    ...(Array.isArray(membershipIds) ? { membership_ids: membershipIds } : {}),
  }),
  listInvitations: () => request('/institutions/current/invitations'),
  createInvitation: (payload) => request('/institutions/current/invitations', 'POST', payload),
  revokeInvitation: (invitationId) => request(`/institutions/current/invitations/${invitationId}`, 'DELETE'),
  getRetentionPolicy: () => request('/institutions/current/retention-policy'),
  updateRetentionPolicy: (payload) => request('/institutions/current/retention-policy', 'PUT', payload),
  listSupportUsers: () => request('/institutions/current/support-users'),
  listSecurityNotices: () => request('/institutions/current/security-notices'),
  listSupportGrants: () => request('/institutions/current/support-grants'),
  createSupportGrant: (payload) => request('/institutions/current/support-grants', 'POST', payload),
  revokeSupportGrant: (grantId) => request(`/institutions/current/support-grants/${grantId}`, 'DELETE'),
  listMySupportRequests: () => request('/auth/support-requests'),
  createImpersonationSession: (payload) => request('/institutions/current/impersonation-sessions', 'POST', payload),
  endImpersonationSession: (sessionId) => request(`/institutions/current/impersonation-sessions/${sessionId}`, 'DELETE'),

  getMarketplacePolicy: () => request('/institutions/current/scenario-marketplace-policy'),
  listCurrentMarketplacePublications: () => request('/institutions/current/scenario-marketplace-publications'),
  listMarketplace: () => request('/scenario-marketplace'),
  publishScenario: (scenarioId, payload = {}) => request(`/scenarios/${scenarioId}/marketplace-publication`, 'POST', payload),
  unpublishScenario: (scenarioId) => request(`/scenarios/${scenarioId}/marketplace-publication`, 'DELETE'),
  importMarketplaceScenario: (listingId, payload = {}) => request(`/scenario-marketplace/${listingId}/import`, 'POST', payload),

  startSupportSession: (institutionId, grantId, breakGlass = false) => request(
    breakGlass ? '/auth/break-glass-access' : '/auth/support-access',
    'POST',
    { institution_id: institutionId, grant_id: grantId },
  ),

  revokeIncidentAccess: (incidentId, userId) => request(`/incidents/${incidentId}/access/${userId}`, 'DELETE'),
};
